
// @ts-ignore
import {getConfig, getLanguageConfig, getSkiTicketBaseConfig} from "../../utils/config-helper";
// @ts-ignore
import {translate} from '@elements/translations';
import {ref, computed, reactive, onMounted, defineComponent, nextTick} from 'vue';
import FormControl from "../../components/form-elements/FormControl.vue";
import LoadingSpinner from "../../components/loading/LoadingSpinner.vue";
import {addParamsToUrl, assertData, postFetcher} from "../../utils/utils";
import {useLoginStore} from '../../stores/LoginStore.ts';
import {storeToRefs} from 'pinia'
import {useTicketStore} from '../../stores/TicketStore';

export default defineComponent({
    name: "LoginForm",
    props: {
        ticketId: {
            type: String,
            required: true,
        }
    },
    components: {
        FormControl,
        LoadingSpinner
    },
    emits: ['loggedInData'],
    setup(props, {emit}) {
        const loginStore = useLoginStore();
        const {isLoggedIn} = storeToRefs(loginStore);
        const {changeLoggedInStatus} = loginStore;
        const isLoading = ref<boolean>(false);
        const form = ref(null);
        const formInstance = ref(null);
        const isValid = ref(false);
        const errorMessage = ref(false);

        const ticketStore = useTicketStore();
        const {
            selectedPriceConfiguration,
            selectedDateStart,
        } = storeToRefs(ticketStore);

        const loginForm = reactive({
            email: "",
            password: "",
            _csrf_token: getConfig('csrfToken'),
            ticketId: props.ticketId,
            option: "",
            selectedDateStart: selectedDateStart.value,
        });

        const onSubmit = async (e: Event) => {
            e.preventDefault();

            loginForm.option = selectedPriceConfiguration.value.upgradeOption;
            isLoading.value = true;

            let url = getSkiTicketBaseConfig().login;
            url = addParamsToUrl(url, new URLSearchParams(loginForm));
            await postFetcher(url).then((data) => {
                if(data.success) {
                    changeLoggedInStatus(true);
                    emit('loggedInData', data);
                    errorMessage.value = false;
                } else {
                    errorMessage.value = data.errorMessage;
                }
                isLoading.value = false;
            }).catch((error) => {
                console.log(error);
            });
        };

        function trackSubmitButtonClick () {
            window.dataLayer.push({
                'event': 'login',
                'method': 'form',
                'location': 'ticketkonfigurator',
            })
        }

        // const isFormValid = computed(() => {
        //     formInstance.value.validate().then((state) => {
        //         isValid.value = state === 'Valid';
        //     });
        // });

        onMounted(() => {
            if(isLoggedIn.value) {
                emit('loggedInData', {success: true});
            }

            // if (form) {
            //     nextTick(() => {
            //         console.log("HERE");
            //         console.log(form);
            //         formValidation.init();
            //         formValidation.getApi(form.value).then((formApi) => {
            //         });
            //     });
            // }
        });

        return {
            onSubmit,
            isLoading,
            loginForm,
            isValid,
            errorMessage,
            form,
            trackSubmitButtonClick,
        }
    }
});
